import React from "react";
import { Spin } from "antd";
import { Button } from "Components";
import StepFooter from "./StepFooter";
import { DIFFICULTY_COLOR } from "../PhishingManager.constants";

interface StepProps {
  onBack: () => void;
  onFinish: () => void;
  showPreview: (id: string | number) => void;
}

const Step5ReviewStart: React.FC<StepProps> = ({
  onBack,
  onFinish,
  showPreview
}) => {
  const { bg, color } = DIFFICULTY_COLOR['Advanced'];
  const isLoading = false;
  return (
    <Spin spinning={isLoading}>
      <div className="review-container step-card">
        <div className="card-header">
          <div className="card-title">Review & Start Test</div>
          <div className="card-subtitle">
            Review the configuration below and start the test campaign
          </div>
        </div>

        <StepDetailSection title="Scenario" cardClass="template-preview">
          <>
            <div className="pm-card-icon">
              <img alt={"img"} src={'https://picsum.photos/seed/template12/400/250'} />
            </div>
            <div className="campaign-card">
              <span className="campaign-card-title">Booking Hotel Scam</span>

              <span className="campaign-card-status" style={{ color, background: bg }}>
                Advanced
              </span>
              <span className="campaign-card-tag">Hospitality-Specific</span>
            </div>
            <Button shape="round" type="primary" ghost onClick={() => showPreview(30)}>
              Preview
            </Button>
          </>
        </StepDetailSection>

        <StepDetailSection title="Test Configuration">
          <CardStep title="Test recipients (required)" subTitle="kamranaka1998@gmail.com" />
        </StepDetailSection>

        <StepDetailSection title="Full Campaign Audience">
          <>
            <CardStep title="Selected method" subTitle="Organization" />
            <CardStep title="Properties selected" subTitle="Entire organization (2,458 users)" />
          </>
        </StepDetailSection>

        <StepDetailSection title="Delivery & Schedule" cardClass="card-grid">
          <>
            <CardStep title="Start date" subTitle="2/7/2027" />
            <CardStep title="Start time" subTitle="9:00 A.M" />
            <CardStep title="Duration" subTitle="7 days" />
            <CardStep title="Timezone" subTitle="Eastern time (ET) (UTC-5)" />
          </>
        </StepDetailSection>
      </div>
      <StepFooter
        nextBtnText="Start test"
        onBack={onBack}
        onNext={onFinish}
        nextBtnDisabled={false}
      />
    </Spin>
  );
};

export default Step5ReviewStart;

const StepDetailSection = ({ title, children, cardClass = '' }: { title: string, cardClass?: string, children: React.ReactElement }) => {
  return <div className="step-detail-section">
    <span className="step-title">{title}</span>
    <div className={`card ${cardClass}`}>{children}</div>
  </div>
}

const CardStep = ({ title, subTitle }: { title: string, subTitle: string }) => {
  return <div className="card-step">
    <div className="card-step-title">{title}</div>
    <div className="card-step-subtitle">{subTitle}</div>
  </div>
}